import React from 'react';

import { MobileFilterWrapper } from '@/modules/CarsStock/components/common.styles';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  setCarBatteryCapacity,
  setPage,
} from '@/store/reducers/cars-stock';
import { RangeType } from '@/typings/common';
import StockFilterRange from '@/components/StockFilterRange';

function BatteryCapacityFilter() {
  const dispatch = useTypedDispatch();
  const selectedBatteryCapacity =
    useTypedSelector(getSelectedFilters).selectedParams.selectedBatteryCapacity;

  const handleBlurBatteryCapacity = (batteryCapacity: RangeType) => {
    dispatch(setCarBatteryCapacity(batteryCapacity));
    dispatch(setPage(1));
  };

  return (
    <MobileFilterWrapper>
      <StockFilterRange
        label="Емкость батареи для электро, кВт*ч"
        values={selectedBatteryCapacity}
        onBlur={handleBlurBatteryCapacity}
      />
    </MobileFilterWrapper>
  );
}

export default BatteryCapacityFilter;
